module.exports = __webpack_public_path__ + "static/media/challenge-multiple.9abf332e.svg";